import { Numbers } from '@buddy-technology/buddy_helpers';
import { PAYMENT_TERMS } from '../models/simpleModels';
/**
 *
 * @typedef {Object} IntervalPricingInfo
 * @property {number} equalPaymentAmount - equally divisible payment amounts after the first month
 * @property {number} firstPayment - the amount to be paid first
 * @property {number} remainingMonths  - how many months of payments left
 */
/**
 * Calculates starting and equal interval pricing values
 * @param  {number} premiumTotal - the policies premiumTotal
 * @param {string} paymentOption - A payment options available on the Price Divisions model
 * @returns {IntervalPricingInfo} Information regarding the interval pricing
 * @memberof module:ionHelpers
 */
const calcIntervalPricing = (premiumTotal, paymentOption = 'SINGLE') => {
    const premiumInCents = Numbers.dollarsToCents(premiumTotal);
    const equalPaymentAmountInCents = Math.floor(premiumInCents / PAYMENT_TERMS[paymentOption]);
    const moduloAmount = premiumInCents % equalPaymentAmountInCents;
    const firstPaymentInCents = ((paymentOption === 'MONTHLY_TWO_UP_FRONT' ? 2 : 1) * equalPaymentAmountInCents) + moduloAmount;
    const equalPaymentAmount = Numbers.centsToDollars(equalPaymentAmountInCents);
    const firstPayment = Numbers.centsToDollars(firstPaymentInCents);
    const remainingMonths = paymentOption === 'MONTHLY_TWO_UP_FRONT' ? PAYMENT_TERMS[paymentOption] - 2 : PAYMENT_TERMS[paymentOption] - 1;
    return {
        equalPaymentAmount,
        firstPayment,
        remainingMonths,
    };
};
export default calcIntervalPricing;
